import React from "react";

import { ERROR_PAGE_LABELS } from "./constants/labels";
import ErrorHandler from "./error-handler";

const { NOT_FOUND } = ERROR_PAGE_LABELS;

const NotFound = () => {
  return <ErrorHandler errorCase={NOT_FOUND} />;
};

export default React.memo(NotFound);
